<template>
    <div class="reo-hour">
        <p class="seleted-text">{{ $t('datepicker.duration') }} {{ start }}:00 - {{ end }}:00</p>
        <div class="hour-main" @click="mainClick" ref="main">
            <div class="basic-line"></div>
            <div class="active-line" :style="{
                left: activeStart,
                right: activeEnd
            }"></div>
            <div class="hour-slider">
                <span class="slider-item" v-for="(item, index) in 25" :key="index"><span>{{ item - 1 }}</span></span>
            </div>
            <span class="slider-controller start" :style="{
                left: startp
            }"></span>
            <span class="slider-controller end" :style="{
                left: endp
            }"></span>
        </div>
    </div>
</template>

<script>
import { debounce } from '@/common/js/utils';
function controllerHandel ( context, mousedownEvent, mousemoveEvent ) {

    let main = $( context.$refs.main )[ 0 ];
    let target = $( mousedownEvent.target );
    let mainLeft = $( context.$refs.main ).offset().left;
    let mainWidth = main.clientWidth;
    let clickLeft = mousemoveEvent.pageX;
    let dis = clickLeft - mainLeft;
    let hour = Math.round( dis * 24 / mainWidth );
    if ( target.hasClass( 'start' )) {

        if ( context.end > hour ) {

            context.start = hour;
            console.log( context.start );

        }

    } else if ( target.hasClass( 'end' )) {

        if ( context.start < hour ) {

            context.end = hour;

        }

    }

}
export default {

    props: {

        startTime: Number,
        endTime: Number

    },
    data () {

        return {

            start: this.startTime,
            end: this.endTime

        };

    },
    mounted () {

        let controller = $( this.$refs.main ).find( '.slider-controller' );
        let _this = this;
        controller.on( 'mousedown', function ( mousedownEvent ) {

            $( _this.$refs.main ).on( 'mousemove', function ( mousemoveEvent ) {

                debounce( controllerHandel( _this, mousedownEvent, mousemoveEvent ), 100 );

            });
            $( _this.$refs.main ).on( 'mouseup mouseleave', function () {

                console.log( 'mouseup mouseleave' );
                $( _this.$refs.main ).unbind( 'mousemove mouseup mouseleave' );

            });

        });
        
    },
    computed: {

        startp () {

            return `${( this.start ) * 100 / 24}%`;

        },
        endp () {

            return `${( this.end ) * 100 / 24}%`;

        },
        activeStart () {

            return `${( this.start ) * 100 / 24}%`;

        },
        activeEnd () {

            return `${( 24 - this.end ) * 100 / 24}%`;

        }

    },
    methods: {

        mainClick ( e ) {

            let main = $( this.$refs.main )[ 0 ];
            let mainLeft = $( this.$refs.main ).offset().left;
            let mainWidth = main.clientWidth;
            let clickLeft = e.pageX;
            let dis = clickLeft - mainLeft;
            let hour = Math.round( dis * 24 / mainWidth );
            if ( this.start > hour ) {

                this.start = hour;

            } else if ( this.start < hour && this.end > hour ) {

                let disStart = hour - this.start;
                let disEnd = this.end - hour;
                if ( disStart > disEnd ) {

                    this.end = hour;

                } else {

                    this.start = hour;

                }

            } else if ( this.end < hour ) {

                this.end = hour;

            }

        }

    },
    watch: {

        start ( start ) {

            if ( start !== this.startTime ) {

                this.$emit( 'changeHandle', start, this.end );

            }

        },
        end ( end ) {

            if ( end !== this.endTime ) {

                this.$emit( 'changeHandle', this.start, end );

            }

        }

    }
};
</script>

<style scoped lang="less">
@top-gap: 10px;
.seleted-text{
    font-size: 0.16rem;
    font-weight: 500;
    text-align: center;
    margin-bottom: 0.16rem;
    @media @mobile{
        font-size: 0.24rem;
    }
}
.reo-hour{
    max-width: 500px;
    margin: 20px 40px 14px;
    padding-top: 34px;
    border-top: 1px solid #ddd;
    @media @mobile{
        margin-left: 15px;
        margin-right: 15px;
        padding-top: 0.2rem;
        margin-bottom: 0.3rem;
    }
}
.hour-main{
    position: relative;
    padding-top: @top-gap;
    cursor: pointer;
    user-select: none;
    margin: 0 0.1rem;
    @media @mobile{
        margin: 0 15px;
    }
}
.basic-line{
    height: 3px;
    width: 100%;
    background-color: #e6e6e6;
    margin: 0 auto;
}
.active-line{
    position: absolute;
    top: @top-gap;
    height: 3px;
    background-color: @theme;
    transition: left 0.1s, right 0.1s;
    // box-shadow: 0px -2px 20px 0px @theme;
}
.hour-slider{
    margin-left: calc(-100% / 50);
    margin-right: calc(-100% / 50);
    &:after{
        display: table;
        content: '';
        clear: both;
    }
}
.slider-item{
    width: calc(100% / 25);
    display: block;
    float: left;
    opacity: 0;
    user-select: none;
    &:nth-child(2n+1),
    &:first-child{
        opacity: 1;
    }
    &:before{
        content: '';
        display: block;
        width: 1px;
        height: 10px;
        background-color: #e7e7e7;
        margin: 0 auto 5px;
    }
    &:nth-child(4n-1){
        span{
            display: none;
        }
        &:before{
            height: 5px;
        }
    }
    span{
        white-space: nowrap;
    }
    @media @mobile{
        font-size: 0.24rem;
    }
}
.slider-controller{
    height: 25px;
    width: 25px;
    border-radius: 100%;
    background-color: #fff;
    display: block;
    transition: left 0.1s;
    box-shadow: 0px 1px 4px 0px #ccc;
    cursor: pointer;
    position: absolute;
    transform: translate(-50%, -50%);
    top: @top-gap;
    @media @mobile{
        height: 0.42rem;
        width: 0.42rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/basic/hour.vue